export const LABORATORY_SHOW_CREATE_MODAL = "LABORATORY_SHOW_CREATE_MODAL";
export const LABORATORY_SHOW_FORMAT_MODAL = "LABORATORY_SHOW_FORMAT_MODAL";
export const LABORATORY_DELETED = "LABORATORY_DELETED";
export const LABORATORY_HIDE_CREATE_MODAL = "LABORATORY_HIDE_CREATE_MODAL";
export const LABORATORY_HIDE_FORMAT_MODAL = "LABORATORY_HIDE_FORMAT_MODAL";
export const ADD_ANALYSIS_TO_LABORATORY = "ADD_ANALYSIS_TO_LABORATORY";
export const SET_ANALYSIS_IN_PROGRESS_NUMBER = "SET_ANALYSIS_IN_PROGRESS_NUMBER";
